import styled from "styled-components";
import { device } from "src/theme/mediaQueries";

export const StyledLayout = styled.div`
  display: flex;
  height: 100vh;
  position: relative;
  overflow: hidden;

  @media ${device.tabletXL} {
    flex-direction: column;
    height: fit-content;
    min-height: 100vh;
  }

  .layout-left,
  .layout-right {
    padding-top: 70px;
    width: 50%;

    @media ${device.tabletXL} {
      padding-top: 120px;
      width: 100%;
    }

    @media ${device.mobileL} {
      padding-top: 50px;
    }
  }

  .layout-left {
    align-items: center;
    background: url("data:image/svg+xml,%3Csvg width='1153' height='659' viewBox='0 0 1153 659' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath opacity='0.06' d='M285.816 519.285C174.416 476.898 25.1117 310.351 -5.99063 241.751L-98 287.189C-73.055 334.967 65.6175 505.211 168.303 603.816C296.659 727.073 457.747 611.309 531.161 569.48C604.576 527.651 606.47 488.61 703.566 475.782C800.662 462.955 821.976 508.13 862.709 504.784C903.442 501.438 944.649 451.243 1008.12 445.665C1058.89 441.204 1104.42 491.77 1120.84 517.611V440.088C1098.11 421.683 995.802 396.028 953.174 418.337C910.547 440.646 869.34 461.839 761.35 440.088C653.36 418.337 613.101 456.82 567.632 493.629C522.162 530.439 425.066 572.268 285.816 519.285Z' fill='white'/%3E%3Cpath opacity='0.06' d='M874.592 268.985C1012.87 126.375 1102.63 113.765 1102.63 113.765L1153 322.15C1124.19 304.493 1090.98 285.093 1028.55 292.544C950.524 301.857 890.652 425.689 820.03 412.883C703.971 401.242 674.022 263.372 619.067 204.04C554.371 134.19 527.51 146.527 454.182 93.9738C275.488 -34.0935 221.909 -333.463 224.708 -355H373.361C377.312 -349.179 407.303 -141.662 594.217 21.3011C630.269 52.7335 668.573 41.4851 729.812 127.633C804.386 273.736 829.156 303.328 874.592 268.985Z' fill='white'/%3E%3Cpath opacity='0.06' d='M291.253 183.522C168.942 129.303 230.399 -30.7294 229.056 -39.9932C155.711 -84.1431 -24.5056 -103.99 -0.804137 32.6019C28.8226 203.342 90.5666 322.058 277.732 436.329C464.896 550.599 590.651 500.172 595.749 379.017C574.002 184.447 413.563 237.74 291.253 183.522Z' fill='white'/%3E%3C/svg%3E%0A"),
      url("data:image/svg+xml,%3Csvg width='539' height='510' viewBox='0 0 539 510' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M204.993 384L202.755 376.64L195 374.5L202.755 372.36L204.993 365L207.245 372.36L215 374.5L207.245 376.64L204.993 384Z' fill='%23E2F3FF'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M63.3715 22.045L60.7817 13.506L51.8059 11.0225L60.7817 8.53898L63.3715 -7.62939e-06L65.9773 8.53898L74.9531 11.0225L65.9773 13.506L63.3715 22.045Z' fill='%23E2F3FF'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M369.245 162.03L366.532 153.064L357.129 150.457L366.532 147.849L369.245 138.883L371.975 147.849L381.378 150.457L371.975 153.064L369.245 162.03Z' fill='%23E2F3FF'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M498.211 385.787L496.237 379.383L489.399 377.52L496.237 375.658L498.211 369.254L500.196 375.658L507.035 377.52L500.196 379.383L498.211 385.787Z' fill='%23E2F3FF'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M104.709 509.239L103.229 504.543L98.1002 503.177L103.229 501.811L104.709 497.115L106.198 501.811L111.327 503.177L106.198 504.543L104.709 509.239Z' fill='%23E2F3FF'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M458.531 462.944L457.051 458.248L451.922 456.882L457.051 455.516L458.531 450.82L460.02 455.516L465.149 456.882L460.02 458.248L458.531 462.944Z' fill='%23E2F3FF'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M238.081 50.7031L236.601 46.0067L231.472 44.6407L236.601 43.2748L238.081 38.5784L239.57 43.2748L244.699 44.6407L239.57 46.0067L238.081 50.7031Z' fill='%23E2F3FF'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M6.60895 276.665L5.12909 271.969L5.72205e-05 270.603L5.12909 269.237L6.60895 264.54L8.09802 269.237L13.2271 270.603L8.09802 271.969L6.60895 276.665Z' fill='%23E2F3FF'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M530.176 38.5791L528.203 32.1749L521.364 30.3122L528.203 28.4496L530.176 22.0454L532.161 28.4496L539 30.3122L532.161 32.1749L530.176 38.5791Z' fill='%23E2F3FF'/%3E%3C/svg%3E%0A")
        center 12.1%,
      ${({ theme }) => theme.bg.gradientBlue};
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
    padding-right: 24px;

    @media ${device.tabletXL} {
      padding-right: 0;
      position: relative;
    }
  }

  .layout-right {
    background: ${({ theme }) => theme.bg.gradientLightBlue};
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-right: 9px;
    overflow: auto;

    @media ${device.tabletXL} {
      flex: 1;
      padding: 36px 0;
    }
  }

  .dragon-wrapper {
    position: relative;
    margin: auto 0 0;
    width: 100%;
    height: 380px;
    aspect-ratio: 1 / 1;
  }

  .dragon-img {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 0;
    display: block;
    margin: 0 auto;
    width: 59.7%;
    z-index: 1;

    @media ${device.tabletXL} {
      max-width: 380px;
      width: 99%;
    }
  }

  .cloud-img {
    bottom: 0;
    left: 49.6%;
    position: absolute;
    transform: translate(-50%, 0);
    width: 51.7%;

    @media ${device.tabletXL} {
      max-width: 305px;
      width: 80%;
    }
  }

  .cloud-separator {
    width: 339px;
    height: 100%;
    inset: 0;
    position: absolute;
    left: 53.2%;
    transform: translate(-50%, 0);

    &-img {
      width: 100%;
      height: 100%;
    }

    @media ${device.tabletXL} {
      display: none;
    }
  }

  .cloud-separator-mobile {
    display: none;
    width: 100%;
    height: 164px;
    margin-top: -164px;

    &-img {
      position: absolute;
      bottom: -10px;
      width: 100%;
      height: auto;
    }

    @media ${device.tabletXL} {
      display: block;
    }

    @media (max-width: 992px) {
      margin-top: -30px;
    }

    @media ${device.mobileL} {
      margin-top: -80px;
    }
  }

  .logo-wrapper {
    display: flex;
    flex-direction: column;
    max-width: 80%;
    margin: 215px 0 0 0;

    @media ${device.desktop} {
      margin: 18vh 0 0;
    }

    @media ${device.tabletXL} {
      margin: 0;
      max-width: 90%;
    }

    img {
      width: 100%;
      margin: 0 0 5px;
      aspect-ratio: auto 731 / 119;
    }

    h3 {
      @media ${device.tabletXL} {
        font-size: ${({ theme }) => theme.fonts.fontSizeS};
      }

      @media ${device.mobileL} {
        font-size: ${({ theme }) => theme.fonts.fontSizeXXXS};
        margin-top: 15px;
      }
    }
  }

  .title-wrapper {
    margin: 216px 0 0;

    @media ${device.desktop} {
      margin: 18vh 0 0;
    }

    @media ${device.tabletXL} {
      margin: 0;
    }
  }

  .title-wrapper,
  .logo-wrapper {
    position: relative;
  }
`;
